export default class RejectionReasonTitle {
  static readonly BAN = "BAN";
  static readonly AVATAR = "プロフィール画像不正";
  static readonly AGE = "年齢制限";
  static readonly ID = "身分証画像不正";
  static readonly PERSONAL_INFO = "登録基本情報不正";
}
